import { useCallback, useState } from 'react';
import noop from 'lodash/noop';
import { getContainer } from '@framework/di/getContainer';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import createAsyncRequest from '@/creditflowresearch/infrastructure/state/createAsyncRequest';
import SubscriptionsRepository from '@/creditflowresearch/infrastructure/repository/SubscriptionsRepository';

export interface ISubscribeBySSIDPayload {
  subscriptionId: string,
}

export interface IUseSubscribeBySSID {
  isFetching: boolean,
  subscribeBySSID: (
    payload: ISubscribeBySSIDPayload,
    onSuccess?: () => void,
    onError?: () => void,
  ) => Promise<void>,
}

export const useSubscribeBySSID = (): IUseSubscribeBySSID => {
  const subscriptionsRepository = getContainer().get(SubscriptionsRepository);
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const subscribeBySSID = useCallback(async (
    payload: ISubscribeBySSIDPayload,
    onSuccess: () => void = noop,
    onError: () => void = noop,
  ) => {
    setIsFetching(true);
    await createAsyncRequest({
      method: subscriptionsRepository.createUserSubscriptionBySSID,
      // Passing onError replaces createAsyncRequest's default error toast, so show it here.
      callbacks: {
        onSuccess: () => onSuccess(),
        onError: ({ error }) => {
          AlertManager.error(getErrorMessage(error));
          onError();
        },
      },
    })(payload);
    setIsFetching(false);
  }, [subscriptionsRepository]);

  return { isFetching, subscribeBySSID };
};
